<mat-accordion #accordion>
  <ng-content></ng-content>
</mat-accordion>